import { render, staticRenderFns } from "./Bilder.vue?vue&type=template&id=147d73f1&"
import script from "./Bilder.vue?vue&type=script&lang=js&"
export * from "./Bilder.vue?vue&type=script&lang=js&"
import style0 from "./Bilder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports